import {
  Component, ViewChild, Input, HostListener, AfterViewInit, OnDestroy,
  ElementRef, NgZone,
  ChangeDetectionStrategy
} from '@angular/core';
import { Tooltip } from './Tooltip';
import { TooltipService } from './tooltip.service';
import Popper from 'popper.js';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TooltipComponent implements AfterViewInit, OnDestroy {

  public tooltip!: Tooltip;
  @Input('tooltip') set setTooltip(tooltip: Tooltip) {
    this.tooltip = tooltip;
    if (this.tooltip) {
      this.create();
    }
  }
  @Input() index = 0;
  @ViewChild('tooltipRef', { static: true }) tooltipElement!: ElementRef;
  @ViewChild('focus') focusElement!: ElementRef;

  over = false;
  hovering = false;


  private popper!: Popper | null;

  constructor(private zone: NgZone, public service: TooltipService) {
  }

  @HostListener('mouseenter') onmouseover() {
    this.over = true;
    setTimeout(() => {
      if (this.over) {
        this.tooltip.hovering = true;
      }
    }, 200);
  }
  @HostListener('mouseleave') onmouseleave() {
    this.over = false;
    setTimeout(() => {
      this.tooltip.hovering = false;
      this.service.hideTooltip(this.tooltip);
    }, 200);
  }

  ngAfterViewInit() {
    this.create();
  }

  get allowNext() {
    if (!this.service.activeContext) { return false; }
    return this.index < this.service.activeContext.tooltips.length - 1;
  }

  nextTip() {
    this.service.nextTip();
  }

  exit() {
    this.service.close();
  }

  create() {
    const tooltip = this.tooltip;
    if (!tooltip || !tooltip.source) { return; }
    const source = tooltip.source.nativeElement;
    this.zone.runOutsideAngular(() => {
      this.popper = new Popper(
        source,
        this.tooltipElement.nativeElement,
        {
          placement: tooltip.placement || 'right',
        });
    });
    setTimeout(() => {
      if (!this.service.activeContext) {
        source.focus();
      } else {
        this.focusElement.nativeElement.focus();
      }
    });
  }

  ngOnDestroy() {
    this.destroy();
  }

  destroy() {
    if (this.popper) {
      const popper = this.popper;
      this.zone.runOutsideAngular(() => {
        popper.destroy();
      });

      this.popper = null;
      this.service.soloTip = undefined;
    }
  }


  removeTags(content: string | undefined): string {
    if (!content) {
      return '';
    }
    let withoutTags = content.replace(/<[^>]*>/g, ' ');
    withoutTags = withoutTags.replace(/\s+/g, ' ');
    return withoutTags.trim();
  }

  getAriaLabel() {
    const label = this.removeTags(this.tooltip.content);

    if (!this.service.activeContext) { return label; }
    if (this.allowNext) {
      return label + ' Hit \'Enter\' to see the next tip, or \'escape\' to exit.';
    } else {
      return label + ' Hit \'Enter\' to finish.';
    }
  }

}
